import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';

const colors = {
  'Admin': 'rgba(231, 76, 60, 1.0)',
  'User 1': 'rgba(52, 152, 219, 0.4)',
  'User 2': 'rgba(46, 204, 113, 0.4)',
  'User 3': 'rgba(155, 89, 182, 0.4)',
  'User 4': 'rgba(52, 73, 94, 0.2)',
  'User 5': 'rgba(52, 73, 94, 0.3)',
  'User 6': 'rgba(52, 73, 94, 0.4)',
  'User 7': 'rgba(52, 73, 94, 0.5)',
  'User 8': 'rgba(52, 73, 94, 0.6)',
  'User 9': 'rgba(52, 73, 94, 0.7)',
  'User 10': 'rgba(52, 73, 94, 0.8)',
  'User 11': 'rgba(52, 73, 94, 0.9)',
  'User 12': 'rgba(52, 73, 94, 1.0)',
};

class Message extends Component {

  renderMessage(message) {
    if (message.type === 'text') {
      return this.renderText(message.content);
    } else if (message.type === '5') {
      return (
        <div>
          {this.renderBase64(message.content)}
          <div style={{ position: 'relative', top: '-128px' }}>
            {this.renderText(message.text)}
          </div>
        </div>
      );
    } else {
      return this.renderBase64(message.content);
    }
  }

  renderText(text) {
    const textSplitted = text.match(/.{21}/g) || [];
    return textSplitted.map((t, i) => <div key={i} style={{ height: '16px', lineHeight: '16px', fontSize: '16px' }}>{t}</div>);
  }

  renderBase64(image) {
    if (!image) {
      return null;
    }
    let base64 = image;
    if (base64.substring(0, 10) !== 'data:image') {
      base64 = `data:image/bmp;base64,${base64}`;
    }
    return <img src={base64} style={{ width: '256px', height: '128px', backgroundColor: '#8A64FF' }} alt="" />;
  }

  render() {
    return (
      <div style={{ backgroundColor: colors[this.props.message.sender] }}>
        <Row style={{ color: this.props.message.sender === 'Admin' ? 'white' : 'black' }}>
          <Col style={{ textAlign: 'center' }}>{moment(new Date(this.props.message.date)).format('DD/MM/YYYY')}</Col>
          <Col style={{ textAlign: 'center' }}>{this.props.message.sender}</Col>
          <Col style={{ textAlign: 'center' }}>{this.props.message.type}</Col>
        </Row>
        <Row>
          <div style={{ textAlign: 'center', width: '256px', height: '128px', margin: 'auto', backgroundColor: '#fff' }}>
            {this.renderMessage(this.props.message)}
          </div>
        </Row>
        <hr/>
      </div>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/manager/message.js